import {nextTick} from "petite-vue";

interface SearchParameter {
    key: string
    terms: []
    range: number[]
    rangeValue: number
    selected: string | string[]
    readonly isEmpty: boolean
    readonly selectedCount: number
    readonly selectedTag: string
    readonly tagTemplate: string
    changeRangeParameterValue(): void
    adjustRangeValue(amount: number): void
    clearParameters(e: Event): void
    closeDetail(e: Event): void
    handleOutsideClick(e: Event): void
    setUpListeners(e: Event): void
}

export default function (props: { key: string, filter: FilterStore }): SearchParameter {
    return {
        key: props.key,
        terms: props.filter.filterParams[props.key]?.terms ?? null,
        range: props.filter.filterParams[props.key]?.range ?? null,
        rangeValue: props.filter.filterParams[props.key]?.rangeValue ?? 0,
        get selected() {
            return props.filter.selectedParams[this.key]
        },
        get isEmpty() {
            return this.selected && !this.selected.length || this.selected === "default"
        },
        get selectedTag() {
            if (document.body.classList.contains('is-mobile') || this.isEmpty) return ''

            return Array.isArray(this.selected) && this.selected.length > 1
                ? `${props.filter.filterParams[props.key]?.label ?? ''} (${this.selected.length})`
                : !this.range ? (this.terms ?? []).find((term: SearchResult) =>
                        term.slug === (Array.isArray(this.selected) ? this.selected[0] : this.selected))?.name
                    : this.tagTemplate.replace('%value%', ` ${this.rangeValue.toLocaleString()} `)
        },
        get selectedCount() {
            return this.isEmpty ? 0 : Array.isArray(this.selected) ? this.selected.length : 1
        },
        get tagTemplate() {
            const el = document.querySelector(`[data-parameter="${props.key}"]`),
                tagTemplate = el?.querySelector('[data-tag-template]')
            return tagTemplate?.getAttribute('data-tag-template')
                    .replace(' %value% ', '%value%')
                ?? (props.filter.filterParams[props.key]?.tagTemplate ?? '%value%')
        },
        async changeRangeParameterValue() {
            await nextTick(() => {
                props.filter.selectedParams[this.key] = this.rangeValue.toString()
            })
        },
        adjustRangeValue(amount) {
            this.rangeValue += amount
            this.changeRangeParameterValue()
        },
        clearParameters(e) {
            this.closeDetail(e)
            props.filter.selectedParams[this.key] = Array.isArray(props.filter.selectedParams[this.key]) ? [] : "default"
            props.filter.submitFilter()
        },
        closeDetail(e) {
            const detail = (e.target as HTMLElement)?.closest('details')
            if (detail) detail.open = false
        },
        handleOutsideClick(e) {
            const detail: HTMLDetailsElement = document.querySelector(`[data-parameter="${this.key}"]`)
            if (detail.contains(e.target as HTMLElement)) return

            detail.open = false
        },
        setUpListeners(e) {
            if (document.body.classList.contains('is-mobile')) return

            const detail = e.target as HTMLDetailsElement
            document[detail.open ? "addEventListener" : "removeEventListener"]('click', this.handleOutsideClick)
        }
    }
}
